// extracted by mini-css-extract-plugin
module.exports = {"trustPilotBanner":"TrustPilotBanner_trustPilotBanner__EQ0KG","text":"TrustPilotBanner_text__gNSF_","stars":"TrustPilotBanner_stars__ykixG"};